import React, {useMemo} from 'react'
import styled from 'styled-components'

import Card from 'components/blocks/blockPartials/card'


type Props = {
    product: any,
    mainImageUrl?: any,
    mainImageMode?: string,
    displaySettings?: [string],
    className?: string
}

const formatPrice = (value) => {
    // First replace gets rid of unnecessry zeros (e.g. 34.00 becomes 34). Second replace puts commas into thousands and millions
    let formattedPrice = (Math.round(value * 100) / 100).toFixed(2).replace(/(\d+)([.,]0+)/, "$1").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return formattedPrice
}

// Component
const Component: React.FC<Props> = (props) => {

    const pricingString = useMemo(() => {

        let buyPricing = props.product?.content?.pricing_structure.filter(item => item.component === 'buy')
        let shortTermHirePricing = props.product?.content?.pricing_structure.filter(item => item.component === 'short-term-hire')

        if(buyPricing.length > 0){
            return `From £${formatPrice(buyPricing[0].purchase_price)}`
        }
        else if(shortTermHirePricing.length > 0){
            return `Hire from £${formatPrice(shortTermHirePricing[0].price_1)}p/w`
        }

    }, [props.product?.content?.pricing_structure])

	return(

        <StyledComponent 
            className={`productCard ${props.className ? props.className : ''}`}
        >

            <Card
                mainImageUrl={props.product?.content?.image_gallery[0]?.image}
                mainImageMode="containAndPreserveAspectRatio"
                alignContent="center"
                title={props.product?.content.name}
                displaySettings={['minimizeOnMobile', 'minimizeOnDesktop']}
                subtitle={pricingString}
                link={{
                    linktype: 'link',
                    href: '/products/[slug]',
                    as: `/${props.product?.full_slug}`
                }}
            />

        </StyledComponent>
        
	)

}


export default Component


// Styles
const StyledComponent = styled.div`

    display: flex;

    > *{
        display: flex;
        width: 100%;
    }

`